import { useInfiniteQuery } from '@tanstack/react-query'

import type { ParentScreenshotRead } from '@/client'
import { parentReadDeviceScreenshotsInfiniteOptions } from '@/client/@tanstack/react-query.gen'
import { nextOffset } from '@/lib/offset-paging'
import { PARENT_POLL_INTERVAL_MS, parentQueryDefaults } from '@/lib/parent-query'

const PAGE_SIZE = 50

export function useParentScreenshotGallery(deviceId: string) {
  const query = useInfiniteQuery({
    ...parentReadDeviceScreenshotsInfiniteOptions({
      path: { device_id: deviceId },
      query: { limit: PAGE_SIZE },
    }),
    ...parentQueryDefaults,
    refetchInterval: PARENT_POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    initialPageParam: 0,
    getNextPageParam: nextOffset,
  })
  const seen = new Set<string>()
  const screenshots: ParentScreenshotRead[] = []
  for (const page of query.data?.pages ?? []) {
    for (const shot of page.items) {
      if (!seen.has(shot.id)) {
        seen.add(shot.id)
        screenshots.push(shot)
      }
    }
  }
  return { query, screenshots }
}
